import type { AnalyticsResponse } from "@sakura-tech-lab/dashboard-api";

import { analyticsApi } from "@/services/dashboard-api.client";

export interface AnalyticsEvent {
  id: string;
  eventType: string;
  sessionId: string;
  timestamp: string;
  metadata: Record<string, any>;
  clientIp: string;
  userAgent: string;
  deviceType: string;
  createdAt: string;
}

export interface RecentActivityResponse {
  success: boolean;
  data: AnalyticsEvent[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
  requestId: string;
}

const normalizeRecentActivity = (
  response: AnalyticsResponse,
  requestedPage: number,
  requestedLimit: number,
): RecentActivityResponse => ({
  success: response.success ?? false,
  data: (response.data ?? []).map((event) => ({
    id: event.id ?? "",
    eventType: event.eventType ?? "",
    sessionId: event.sessionId ?? "",
    timestamp: event.timestamp?.toISOString() ?? "",
    metadata: event.metadata ?? {},
    clientIp: event.clientIp ?? "",
    userAgent: event.userAgent ?? "",
    deviceType: event.deviceType ?? "",
    createdAt: event.createdAt?.toISOString() ?? "",
  })),
  pagination: {
    page: response.pagination?.page ?? requestedPage,
    limit: response.pagination?.limit ?? requestedLimit,
    total: response.pagination?.total ?? 0,
    totalPages: response.pagination?.totalPages ?? 0,
    hasNext: response.pagination?.hasNext ?? false,
    hasPrev: response.pagination?.hasPrev ?? false,
  },
  requestId: response.requestId ?? "",
});

export const getRecentActivity = async (
  limit: number = 10,
  page: number = 1,
  eventType?: string,
): Promise<RecentActivityResponse> => {
  const response = await analyticsApi.listRecentAnalyticsEvents({ limit, page, eventType });
  return normalizeRecentActivity(response, page, limit);
};
